import { Actions, Context } from "vuex-smart-module";
import UserState from "@/store/modules/user/user-state";
import UserGetters from "@/store/modules/user/user-getters";
import UserMutations from "@/store/modules/user/user-mutations";
import root from "@/store/modules";
import { Store } from "vuex";
import { store } from "@/store";
import esquireClient from "@/modules/esquire-client";
import keycloak from "@/auth/keycloak";
import SessionData from "@/http/data/session-data";

export default class UserActions extends Actions<UserState, UserGetters, UserMutations, UserActions> {
    declare rootContext: Context<typeof root>;

    $init(_store: Store<typeof store>): void {
        this.rootContext = root.context(_store);
        super.$init(_store);
    }

    async initialize(): Promise<void> {
        if (keycloak.authenticated && keycloak.token) {
            esquireClient.defaults.headers.common["Authorization"] = `Bearer ${keycloak.token}`;

            this.mutations.setSession(await this.dispatch("me") as SessionData);
        } else {
            this.mutations.setSession(null);
        }

        this.mutations.setIsInitialized(true);
    }

    async setKeycloakSession(session: { token: string; refreshToken?: string; authenticated: boolean }): Promise<void> {
        esquireClient.defaults.headers.common["Authorization"] = `Bearer ${session.token}`;

        this.mutations.setSession(await this.dispatch("me") as SessionData);

        this.mutations.setIsInitialized(true);
    }

    async updateToken(token: string): Promise<void> {
        if (!this.state.session) return;

        esquireClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        this.mutations.setSession(await this.dispatch("me") as SessionData);
    }

    async logout(): Promise<void> {
        this.mutations.setSession(null);
        delete esquireClient.defaults.headers.common["Authorization"];

        const modules = this.rootContext.modules;
        modules.building.mutations.setIsInitialized(false);
        modules.contract.mutations.setIsInitialized(false);
        modules.job.mutations.setIsInitialized(false);
        modules.unit.mutations.setIsInitialized(false);
        modules.unitCheck.mutations.setIsInitialized(false);
        modules.user.mutations.setIsInitialized(false);

        await keycloak.logout({
            redirectUri: `${window.location.origin}/`
        });
    }

    async me(): Promise<SessionData> {
        const response = await esquireClient.get("auth/me");

        return new SessionData(response.data);
    }
}
